import { createContext, RefObject, useContext } from 'react'

/**
 * Where dialogs, selects and dropdown menus portal to. Unset (the admin), they go to `document.body`; the embedded
 * theme builder points it at `.theme-builder-root` so its scoped styles apply to them, the media picker included.
 */
export const PortalContext = createContext<RefObject<HTMLDivElement | null>>({ current: null })

export const usePortalContainer = () => {
  return useContext(PortalContext).current ?? undefined
}
